<template src="./html/Buttons.html"></template>

<script>
	import swal from 'sweetalert2'
	import Ladda from 'ladda'
	import CollectionAccounts from './CollectionAccounts'
	import SendEmail from './SendEmail'

	export default {
		props: ['user', 'isAuth', 'data'],
		components: {
			'collection-accounts': CollectionAccounts,
			'send-email': SendEmail,
		},
		data () {
			return {
				loading: false,
				statuses: null,
				intervals: null,
				paymentMethods: null,
			}
		},
		created () {
			this.init()
		},
		methods: {
			init() {
				this.getStatuses()
				this.getIntervals()
				this.getPayMentMethods()
			},
			reload() {
				this.$emit('reload')
			},
			getStatuses() {
				this.$http.get('admin/agreements/statuses')
					.then(response => {
						this.statuses = response.body
					})
			},
			getIntervals() {
				this.$http.get('admin/time/intervals')
					.then(response => {
						this.intervals = response.body
					})
			},
			getPayMentMethods() {
				this.$http.get('admin/management/payment/methods')
				.then(response => {
					this.paymentMethods = response.body
				}).catch(function(response) {
					console.log(response)
				})
			},
			changeStatus(el) {
				var select = el.currentTarget
				select.setAttribute('disabled', true)
				this.loading = true
				if(this.data.status.id) {
					this.$http.get('admin/agreements/' + this.data.id + '/change/status/' + this.data.status.id)
						.then(response => {
							this.loading = false
							select.removeAttribute('disabled')
							this.reload()
							this.$emit('reload')
						}).catch(response => {
							this.loading = false
							select.removeAttribute('disabled')
							if(response.status == 409) {
								swal({
									title: response.statusText,
									text: response.body,
									type: 'warning',
								})
							}
							this.reload()
							this.$emit('reload')
						})
				}
			},
			changeInterval(el) {
				var select = el.currentTarget
				select.setAttribute('disabled', true)
				this.loading = true
				if(this.data.status.id) {
					this.$http.get('admin/agreements/' + this.data.id + '/change/interval/' + this.data.time_interval_id)
						.then(response => {
							this.loading = false
							select.removeAttribute('disabled')
							this.reload()
						}).catch(response => {
							this.loading = false
							select.removeAttribute('disabled')
							if(response.status == 409) {
								swal({
									title: response.statusText,
									text: response.body,
									type: 'warning',
								})
							}
							this.reload()
						})
				}
			},
			changePaymentMethod(el) {
				var select = el.currentTarget
				select.setAttribute('disabled', true)
				this.loading = true
				if(this.data.payment_method_id) {
					this.$http.get('admin/agreements/' + this.data.id + '/change/payment/method/' + this.data.payment_method_id)
						.then(response => {
							this.loading = false
							select.removeAttribute('disabled')
							this.$emit('reload')
						}).catch(response => {
							this.loading = false
							select.removeAttribute('disabled')
							if(response.status == 409) {
								swal({
									title: response.statusText,
									text: response.body,
									type: 'warning',
								})
							}
							this.$emit('reload')
						})
				}
			},
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/agreements/views/Buttons.vue